import React, { useEffect, useState } from 'react'
import DashboardNav from '../../components/Nav/DashboardNav'
import search_icon from '../assets/search.svg'
import { useNavigate,  useLocation } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'
import CustomDatePicker from '../../components/CustomDatePicker/CustomDatePicker'
import InfoIcon from '../assets/infoIcon.svg'
import ProgressBarSelector from '../../components/ProgressBarSelector/ProgressBarSelector'
import fullStar from '../../components/Review/assets/fullStar.svg'
import emptyStar from '../../components/Review/assets/emptyStar.svg'
import Footer from '../../components/Footer/Footer'
import RateCountrySelector from './RateCountrySelector'
import RateCategorySelector from './RateCategorySelector'
import RateEventSelector from './RateEventSelector'
import RateVendorSelector from './RateVendorSelector'
import errorIcon from '../../components/assets/error.svg';
import successIcon from '../../components/assets/success.svg';
import baseUrl from '../../components/baseUrl'
import SuccessModal from './Successmodal'
import axios from 'axios'
import { LOCAL_STORAGE_TOKEN_KEY } from '../../utils/constants';


const Rate = ({ reviewData, vendorCountryData, categoryData, eventData, vendorData }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const [country, setCountry] = useState('')
  const [category, setCategory] = useState('')
  const [vendor, setVendor] = useState('')
  const [vendorId, setVendorId] = useState(null)
  const [selectedEvent, setEvent] = useState('')
  const [eventId, setEventId] = useState(null)
  const [vendorFound, setVendorFound] = useState(false)
  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(false); // Track loading state
  const [showModal, setShowModal] = useState(false);
  const passedVendor = location.state?.vendor;

  const [step, setStep] = useState(1);

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden"; // Disable scroll
    } else {
      document.body.style.overflow = "auto"; // Enable scroll when modal closes
    }

    return () => {
      document.body.style.overflow = "auto"; // Cleanup when unmounting
    };
  }, [showModal]);

  const [createAccount, setCreateAccount] = useState(null)
  const [user, setUser] = useState(null)
  const [accessToken, setAccessToken] = useState()
  const [selectedCurrency, setSelectedCurrency] = useState({ id: 3, name: 'Ghana Cedis', symbol: "GHS" });

  const [rating, setRating] = useState(0);
  const [hireAgain, setHireAgain] = useState('')
  const [recommendAgain, setRecommendAgain] = useState('')
  const [selectedWords, setSelectedWords] = useState([]);
  const [showMore, setShowMore] = useState(false);

  // Error Messages
  const [searchError, setSearchError] = useState('');
  const [countryError, setCountryError] = useState('');
  const [categoryError, setCategoryError] = useState('');
  const [eventError, setEventError] = useState('');
  const [vendorError, setVendorError] = useState('');
  const [rateError, setRateError] = useState('');
  const [eventDateError, setEventDateError] = useState('');
  const [commentError, setCommentError] = useState('');
  const [recommendAgainError, setRecommendAgainError] = useState('');
  const [hireAgainError, setHireAgainError] = useState('');
  const [threeWordsError, setthreeWordsError] = useState('');
  const [selectedCountry, setSelectedCountry] = useState(null);

  // To keep track of filtered options
  const [filteredVendors, setFilteredVendors] = useState(vendorData);
  const [filteredCountries, setFilteredCountries] = useState(vendorCountryData);
  const [filteredCategories, setFilteredCategories] = useState(categoryData);
  const [filteredEvents, setFilteredEvents] = useState(eventData);

  //Open Calendar
  const [openCalendar, setOpenCalendar] = useState(false)

  //  Service Estimate Amount
  const [estimateAmount, setEstimateAmount] = useState('')

  //Comment

  const [comment, setComment] = useState('')

  const currencies = [
    { id: 1, name: 'US Dollars', symbol: "USD" },
    { id: 2, name: 'Pound Sterling', symbol: "GBP" },
    { id: 3, name: 'Ghana Cedis', symbol: "GHS" },
    { id: 4, name: 'Naira', symbol: "NGN" },
  ];


  const words = [
    "Helpful", "Considerate", "Rude", "Offensive", "Thoughtful", "Supportive", "Tardy", "Arrogant", "Patient", "Understanding", "Unfriendly", "Snobbish", "Punctual", "Compassionate", "Direct", "Self-absorbed", "Friendly", "Encouraging", "Apathetic", "Egotistical"
  ];

  const formatDate = (date) => {
    if (!date) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day} - ${month} - ${year}`;
  };

  const handleClick = (index) => {
    setSearchError('')
    setRating(index + 1); // Set rating based on the star clicked
  };

  // Function to handle vendor selection and automatically filter categories and countries
  const handleVendorSelect = (selectedVendor, vendor_id) => {
    setVendor(selectedVendor);
    setVendorId(vendor_id);

    // Filter categories and countries based on selected vendor
    const vendorCategories = vendorData.filter(v => v.vendor_name === selectedVendor)
      .map(v => v.category.category_name);
    const vendorCountries = vendorData.filter(v => v.vendor_name === selectedVendor)
      .map(v => v.vendor_country.vendor_country_name);

    //setFilteredCategories(categoryData.filter(c => vendorCategories.includes(c.category_name)));
    // setFilteredCountries(vendorCountryData.filter(c => vendorCountries.includes(c.vendor_country_name)));
  };


  // Function to handle event selection and automatically filter events 
  const handleEventSelect = (selectedEvent, event_id) => {
    setEvent(selectedEvent);
    setEventId(event_id);
  };





  // Function to handle category selection and automatically filter vendors and countries
  const handleCategorySelect = (selectedCategory) => {
    setCategory(selectedCategory);

    // Start filtering vendors by category
    let categoryVendors = vendorData.filter(v => v.category.category_name === selectedCategory);

    // If a country is selected, filter vendors by both country and category
    if (selectedCountry) {
      categoryVendors = categoryVendors.filter(v => v.vendor_country.vendor_country_name === selectedCountry);
    }

    // Get unique country names for filtered vendors
    const categoryCountryNames = [...new Set(categoryVendors.map(v => v.vendor_country.vendor_country_name))];
    const categoryCountries = vendorCountryData.filter(v => categoryCountryNames.includes(v.vendor_country_name));

    setFilteredVendors(categoryVendors);
    //setFilteredCountries(categoryCountries);
  };

  // Function to handle country selection and automatically filter vendors and categories
  const handleCountrySelect = (selectedCountry) => {
    setSelectedCountry(selectedCountry); // Store selected country in state
    setCountry(selectedCountry);

    // Filter vendors based on the selected country
    const countryVendors = vendorData.filter(v => v.vendor_country.vendor_country_name === selectedCountry);

    // Get unique category names for vendors in the selected country
    const countryCategoryNames = [...new Set(countryVendors.map(v => v.category.category_name))];

    // Filter categories based on selected country
    const countryCategories = categoryData.filter(c => countryCategoryNames.includes(c.category_name));

    setFilteredVendors(countryVendors);
    // setFilteredCategories(countryCategories);
  };



  // Handle Search functionality
  const handleSearch = () => {
    if (vendor?.length < 1 && category?.length < 1 && country?.length < 1) {
      setSearchError('Invalid Search');
      return;
    } else if (vendor?.length < 1) {
      setSearchError('Vendor is Required');
      return;
    } else if (category?.length < 1 && country?.length < 1) {
      setSearchError('Category or Country is Required');
      return;
    }

    else {

      let filterSearchedVendor = vendorData;
      if (vendor?.length > 0) {
        filterSearchedVendor = filterSearchedVendor?.filter(vendorItem =>
          vendorItem?.vendor_name?.toLowerCase()?.includes(vendor?.toLowerCase())
        );
      }

      if (category?.length > 0) {
        filterSearchedVendor = filterSearchedVendor?.filter(vendorItem =>
          vendorItem?.category?.category_name?.toLowerCase()?.includes(category?.toLowerCase())
        );
      }

      if (country?.length > 0) {
        filterSearchedVendor = filterSearchedVendor?.filter(vendorItem =>
          vendorItem?.vendor_country?.vendor_country_name?.toLowerCase()?.includes(country?.toLowerCase())
        );
      }

      // if (filterSearchedVendor.length === 0) {
      //   setSearchError('No vendors found for the given search criteria.');
      // } else {
      //   setSearchError('');
      //   // Assuming filterSearchedVendor contains only one vendor data point
      //   setVendorId(filterSearchedVendor[0]?.vendor_id) // Extract vendor_id from filterSearchedVendor
      //   setVendorFound(true)
      //   setTimeout(() => {
      //     setVendorFound(false)
      //   }, 1000)
      //   // Filter reviewData based on the vendor_id
      //   const filteredVendorData = reviewData.filter(review => review.vendor.vendor_id === vendorId);
      //   // navigate('/vendor', { state: { vendor: filterSearchedVendor[0], filteredVendorData: filteredVendorData } });
      // }
    }
  };


  const handleEstimateAmountChange = (e) => {
    let value = e.target.value;

    // Remove all non-numeric characters (except the decimal point)
    value = value.replace(/[^0-9.]/g, '');

    // Format the number with commas
    const formattedValue = new Intl.NumberFormat().format(value);

    // Update the state with the formatted value
    setEstimateAmount(formattedValue === "0" ? "" : formattedValue);
  };

  // Decode the data 
  function decodeData(data) {
    return atob(data); // Base64 encoding
  }

  useEffect(() => {
    const storeToken = window.localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
    // Decode the JWT token
    const decodedToken = storeToken ? decodeData(storeToken) : null;
    const userInfo = decodedToken ? jwtDecode(decodedToken) : null;
    if (userInfo) {
      setAccessToken(decodedToken)
      setUser(userInfo?.user)
    }
    else {
      navigate('/');
    }
  }, [navigate])

  useEffect(() => {
    setFilteredCountries(vendorCountryData)
    setFilteredEvents(eventData)
    setFilteredCategories(categoryData)
    setFilteredVendors(vendorData)
  }, [vendorCountryData, categoryData, vendorData])

  useEffect(() => {
  if (passedVendor) {
    setVendor(passedVendor.vendor_name || passedVendor);
    setVendorId(passedVendor.vendor_id || passedVendor._id);
    setCategory(passedVendor.category?.category_name || '');
    setCountry(passedVendor.vendor_country?.vendor_country_name || '');
    setSelectedCountry(passedVendor.vendor_country?.vendor_country_name || '');
  }
}, [passedVendor]);


  const Star = ({ filled, onClick }) => (
    <span onClick={onClick} style={{ cursor: 'pointer' }} className='transform transition-all ease-in-out duration-300'>
      {filled ? <img src={fullStar} alt="fullStar" className='size-[49px] lg:size-[31px] transform transition-all ease-in-out duration-300' /> : <img src={emptyStar} alt="emptyStar" className='size-[49px] lg:size-[31px] transform transition-all ease-in-out duration-300' />} {/* Use actual star images if you have them */}
    </span>
  );


  const toggleWord = (word) => {
    setSelectedWords((prevSelected) => {
      if (prevSelected.includes(word)) {
        return prevSelected.filter((item) => item !== word);
      }
      if (prevSelected.length < 3) {
        return [...prevSelected, word];
      }
      return prevSelected;
    });
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Smooth scrolling behavior
    });
  };

  const handleSubmit = async (event) => {
    setLoading(true);
    // Validate required fields
    if (!vendor) {
      setVendorError('Vendor is required');
      scrollToTop();
      setLoading(false);
    } else {
      setVendorError('');
    }
    if (!category) {
      setCategoryError('Category is required');
      scrollToTop();
      setLoading(false);
    } else {
      setCategoryError('');
    }
    if (!selectedEvent) {
      setEventError('Event is required');
      scrollToTop();
      setLoading(false);
    } else {
      setEventError('');
    }
    if (!country) {
      setCountryError('Country is required');
      scrollToTop();
      setLoading(false);
    } else {
      setCountryError('');
    }
    if (!selectedDate) {
      setEventDateError("Event Date is required");
      scrollToTop();
      setLoading(false);
    } else {
      setEventDateError('');
    }
    if (rating === 0) {
      setRateError("Rate is required");
      window.scrollTo({ top: 350, behavior: 'smooth' });
      setLoading(false);
    } else {
      setRateError('');
    }
    if (!comment) {
      setCommentError("Comment is required");
      window.scrollTo({ top: 400, behavior: 'smooth' });
      setLoading(false);
    } else {
      setCommentError('');
    }
    if (!hireAgain) {
      setHireAgainError("Select hire-again option");
      scrollToTop();
      setLoading(false);
    } else {
      setHireAgainError('');
    }
    if (!recommendAgain) {
      setRecommendAgainError("Select recommend-again option");
      scrollToTop();
      setLoading(false);
    } else {
      setRecommendAgainError('');
    }
    if (selectedWords.length === 0) {
      setthreeWordsError("Select at least one description");
      scrollToTop();
      setLoading(false);
    } else {
      setthreeWordsError('');
    }

    // Proceed only if all validations pass
    if (vendor && category && selectedEvent && country && selectedDate && rating > 0 && comment && hireAgain && recommendAgain && selectedWords.length > 0) {
      const requestData = {
        rating_score: rating,
        vendor_id: vendorId,
        event_id: eventId,
        service_estimate: estimateAmount ? estimateAmount : 0,
        service_estimate_currency: selectedCurrency.symbol,
        comment: comment,
        event_date: selectedDate,
        feedback_date: selectedDate,
        hire_again: hireAgain === 'Yes',
        recommend_again: recommendAgain === 'Yes',
        three_words: selectedWords,
      };

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${baseUrl}/ratings`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${JSON.parse(accessToken)}`

        },
        data: requestData
      };

      try {
        const response = await axios.request(config);

        if (response.data.success) {
          setShowModal(true); // Show success modal

        } else {
          alert("Error: " + response.data.error);
          setLoading(false);
        }
      } catch (error) {
        alert("An error occurred. Please try again.");
      } finally {
        setLoading(false);
      }
    }
  };


  const toggleShowMore = () => {
    setShowMore(!showMore);
  };


  const resetFields = () => {
    window.location.reload();

  };

  return (
    <div>
      <DashboardNav />
      <div className='px-[24px] md:px-[95px]  lg:pr-[90px] lg:pl-[90px] pt-[120px]  md:pt-[150px]  lg:pt-[197px] pb-[60px] w-full flex  flex-col'>
        <div className="w-[270px] mx-auto md:w-[529px]  lg:hidden mb-[30px] md:mb-[48px] flex slef-center items-center justify-center h-[54px]">
          {/* STEP 1 */}
          <div className="relative flex flex-col items-center shrink-0">
            <div className={`w-9 h-9 flex items-center justify-center rounded-full 
      ${step === 1 ? "bg-[#0079FF] text-white" : "bg-[#E5E5E580] text-black "} 
      font-medium`}>
              1
            </div>
            <h1 className=' absolute -bottom-[18px] left-1/2 -translate-x-1/2 text-center whitespace-nowrap text-[10px] mt-[5px] font-medium text-[#aaaaaa]'>Rating Section</h1>

          </div>


          {/* LINE */}
          <div className="flex flex-1 h-[1px] bg-[#e5e5e5] self-center"></div>

          {/* STEP 2 */}
          <div className="relative flex flex-col items-center shrink-0">
            <div className={`w-9 h-9 flex items-center justify-center rounded-full 
      ${step === 2 ? "bg-[#0079FF] text-white" : "bg-[#E5E5E580] text-black "} 
      font-medium`}>
              2
            </div>
            <h1 className='absolute -bottom-[18px] left-1/2 -translate-x-1/2 text-center whitespace-nowrap text-[10px] mt-[5px] font-medium text-[#aaaaaa]'>Price estimate</h1>
          </div>


        </div>
        {vendor && (
          <>
            <p className='text-[32px] leading-[32.4px] text-[#000045] font-bold mt-[10px] lg:mt-0 mb-[5px] text-center'>
              {vendor}
            </p>
            <p className='font-regular flex items-center text-[#000045] text-[16px] text-center mb-[30px] justify-center'>
              Leave a review for this vendor
            </p>
          </>
        )}
        {showModal && (
          <>

            <SuccessModal setShowModal={setShowModal} resetFields={resetFields} page="rate" />

          </>


        )}


        {/**Error Display */}
        {countryError === "Country is required" || categoryError === "Category is required" || eventError === "Event is required" || searchError === "Country is required" ? (
          <div className='w-full flex items-center justify-center mb-[14px] transform transition-all ease-in-out duration-300'>
            <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[30px] px-[12px] h-[30px] text-[#EB0728]  text-[10px] leading-[12.13px]">
              <img src={errorIcon} alt="" className=" size-[14px]" />
              <p className=" font-normal ">
                {countryError}
              </p>
              <p className=" font-normal  ">
                {categoryError}
              </p>
              <p className=" font-normal ">
                {vendorError}
              </p>
            </div>
          </div>
        ) : null}



        {/**Large Screen Search */}
        {/* <div className=' w-full hidden md:flex items-center justify-center'>
          <div className='w-full max-w-[1000px] flex gap-4 justify-between '>
            <RateCountrySelector countryError={countryError} setCountryError={setCountryError} vendorCountryData={filteredCountries} handleCountrySelect={handleCountrySelect} device="large" />
            <RateEventSelector eventError={eventError} setEventError={setEventError} eventData={filteredEvents} handleEventSelect={handleEventSelect} device="large" />
            <RateCategorySelector categoryError={categoryError} setCategoryError={setCategoryError} categoryData={filteredCategories} handleCategorySelect={handleCategorySelect} device="large" />

            <div className='w-full flex'>
              <RateVendorSelector vendorError={vendorError} setVendorError={setVendorError} vendorData={filteredVendors} handleVendorSelect={handleVendorSelect} device="large" />
            </div>
          </div>
        </div> */}

        {/* Large Screen Search */}
        <div className='w-full hidden  md:min-w-[480px]  max-w-[848px]  md:flex flex-grow justify-between  shadow-search flex self-center rounded-[80px] z-[80]'>
          <div className={`w-full flex items-center rounded-[80px]  border ${searchError === 'Invalid Search' || countryError === "Country is required" || eventError === "Event is required" || searchError === "Country is required" ? '  border-[#EB0728]' : 'border-[#C1C1C180] '} bg-white transform transition-all ease-in-out duration-300`}>
            <RateCountrySelector countryError={countryError} setCountryError={setCountryError} vendorCountryData={filteredCountries} handleCountrySelect={handleCountrySelect} selectedCountry={country} device="large" />
            <div className='border border-[1.5px] h-[25px] bg-[#C1C1C1]' />
            <RateCategorySelector categoryError={categoryError} setCategoryError={setCategoryError} categoryData={filteredCategories} handleCategorySelect={handleCategorySelect} selectedCategory={category} device="large" />
            <div className='border border-[1.5px] h-[25px] bg-[#C1C1C1]' />
            <RateVendorSelector vendorError={vendorError} setVendorError={setVendorError} vendorData={filteredVendors} handleVendorSelect={handleVendorSelect} selectedVendor={vendor} device="large" />
          </div>
        </div>



        {/**Small Screen Search */}
        <div className='w-full flex md:hidden flex-col gap-[10px] sm:px-[32px]'>
          <RateCountrySelector countryError={countryError} setCountryError={setCountryError} vendorCountryData={filteredCountries} handleCountrySelect={handleCountrySelect} selectedCountry={country} device="small" />
          {/* <RateEventSelector eventError={eventError} setEventError={setEventError} eventData={filteredEvents} handleEventSelect={handleEventSelect} device="small" /> */}
          <RateCategorySelector categoryError={categoryError} setCategoryError={setCategoryError} categoryData={filteredCategories} handleCategorySelect={handleCategorySelect} selectedCategory={category} device="small" />
          <RateVendorSelector vendorError={vendorError} setVendorError={setVendorError} vendorData={filteredVendors} handleVendorSelect={handleVendorSelect} selectedVendor={vendor} device="small" />
        </div>




        <div className='flex flex-col lg:flex-row  md:mt-[56px] md:gap-[15px] lg:gap-[18px] mg:gap-[21px]'>
          {/* MOBILE STEP 1 */}
          <div className={`${step === 1 ? "block" : "hidden"} lg:block`}>
            <div classname=' flex items-center justify-center '>
              {/* MOBILE STEP 1 */}
              <h1 className='font-black lg:hidden mt-5 flex items-center text-center justify-center text-sm'>Rate this vendor</h1>
              <div className='flex items-center lg:hidden mt-[12px] justify-center md:mb-[27px] '>
                {[...Array(5)].map((_, index) => (
                  <Star
                    key={index}
                    filled={index < rating}
                    onClick={() => handleClick(index)}
                    className='w-[49px] h-[49px]'
                  />
                ))}
              </div>
            </div>
            {/* first div */}

            {/* Experience,three words,rate,hire gaian */}
            <div className='border rounded-[20px] mt-[31px] md:mt-0 md:flex md:flex-1 lg:flex-[1.4] xl:flex-[1.01]'>

              <div className='bg-rate w-full  rounded-[20px]'>

                {/** Wrapped top section inside a white div */}
                <div className='bg-white rounded-[20px] py-[19px] xl:py-[22px] px-[17px] xl:pl-[24px] flex flex-col gap-[17px]'>
                  <p className='text-sm font-black'>Use 3 words to describe this vendor</p>

                  {/** 3 words */}
                  {threeWordsError === "Select at least one description" ? (
                    <div className=' mt-[12px] w-full flex items-center justify-center transform transition-all ease-in-out duration-300'>
                      <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[30px] border-[#EB0728] px-[12px] h-[30px]">
                        <img src={errorIcon} alt="" className=" size-[14px]" />
                        <p className=" font-normal text-[#EB0728] text-[10px] leading-[12.13px]">
                          {threeWordsError}
                        </p>
                      </div>
                    </div>
                  ) : null}

                  <div className=" w-full flex flex-wrap gap-x-[10px] gap-y-[17px] items-center">
                    {words
                      .sort((a, b) => selectedWords.includes(b) - selectedWords.includes(a)) // Sort selected words first
                      .slice(0, 5)
                      .map((word) => (
                        <button
                          key={word}
                          onClick={() => toggleWord(word)}
                          disabled={selectedWords.length >= 3 && !selectedWords.includes(word)}
                          className={`disabled:text-ravash disabled:cursor-not-allowed px-[15px] h-[30px] rounded-[5px] flex items-center justify-center text-center font-medium text-sm sm:text-[16px] sm:leading-[21.6px] ${selectedWords.includes(word) ? 'bg-[#FEAD00] text-white' : 'bg-ravbg'
                            }`}
                        >
                          {word}
                        </button>
                      ))}

                    {showMore &&
                      words
                        .sort((a, b) => selectedWords.includes(b) - selectedWords.includes(a)) // Sort again for "show more" words
                        .slice(5)
                        .map((word) => (
                          <button
                            key={word}
                            onClick={() => toggleWord(word)}
                            disabled={selectedWords.length >= 3 && !selectedWords.includes(word)}
                            className={`disabled:text-ravash disabled:cursor-not-allowed px-[15px] h-[30px] rounded-[5px] flex items-center justify-center text-center font-medium text-sm sm:text-[16px] sm:leading-[21.6px] ${selectedWords.includes(word) ? 'bg-[#FEAD00] text-white' : 'bg-ravbg'
                              }`}
                          >
                            {word}
                          </button>
                        ))}

                    {words.length > 5 && (
                      <button
                        onClick={toggleShowMore}
                        className="px-[8px] flex items-center justify-center text-center font-black text-ravblue text-sm sm:text-[16px] sm:leading-[21.6px]"
                      >
                        {showMore ? 'less' : '+more'}
                      </button>
                    )}
                  </div>


                  {/** Comment */}
                  <div className=' flex flex-col'>
                    {commentError === "Comment is required" && (
                      <div className='w-full flex items-center justify-center mb-[14px] transform transition-all ease-in-out duration-300'>
                        <div className="w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[20px] px-[12px] h-[30px]">
                          <img src={errorIcon} alt="" className="size-[14px]" />
                          <p className="font-normal text-[#EB0728] text-[10px] leading-[12.13px]">{commentError}</p>
                        </div>
                      </div>
                    )}
                    <div className='w-full flex'>
                      <textarea
                        value={comment} // Ensure this is controlled by state
                        onChange={(e) => setComment(e.target.value)}
                        name="comment"
                        id="comment"
                        placeholder='Tell us about your experience (Max 500 characters)...'
                        className={`focus:outline-none  font-medium resize-none w-full max-w-[922px] min-h-[227px]  md:min-h-[207px] ${commentError === "Comment is required" ? " border border-[#EB0728]" : ""} placeholder:text-ravinput text-sm`}
                      ></textarea>
                    </div>
                  </div>







                </div>

                <div className='px-[25px] md:pl-[37px] pt-[24px] pb-[28px] flex flex-col gap-[15px] rounded-[20px]'>
                  {/** Hire Again Section */}
                  {hireAgainError === "Select hire-again option" ? (
                    <div className='w-full flex items-center justify-center transform transition-all ease-in-out duration-300'>
                      <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[30px] border-solid  px-[12px] h-[30px]">
                        <img src={errorIcon} alt="" className=" size-[14px]" />
                        <p className=" font-normal text-[#EB0728] text-[10px] leading-[12.13px]">
                          {hireAgainError}
                        </p>
                      </div>
                    </div>
                  ) : null}
                  <div className='flex gap-[13px] flex-col  text-white lg:flex-row lg:justify-between '>

                    <h1 className=' font-medium text-[16px] leading-[21.6px]'>Would you hire this vendor again?</h1>
                    <div className='flex gap-[10px]'>
                      <button type='button' onClick={() => setHireAgain('Yes')} className={`w-[80px] h-[30px] rounded-[10px] flex items-center justify-center text-center ${hireAgain === "Yes" ? "bg-[#4FBF26] text-white cursor-not-allowed" : "bg-white text-black cursor-pointer"} font-bold text-[16px] leading-[21.6px] transform transition-all ease-in-out duration-300`}>Yes</button>
                      <button type='button' onClick={() => setHireAgain('No')} className={`w-[80px] h-[30px] rounded-[10px] flex items-center justify-center text-center ${hireAgain === "No" ? "bg-[#F32424] text-white cursor-not-allowed" : "bg-white text-black cursor-pointer"} font-bold text-[16px] leading-[21.6px] transform transition-all ease-in-out duration-300`}>No</button>
                    </div>
                  </div>
                  {/**Recommend */}
                  {recommendAgainError === "Select recommend-again option" ? (
                    <div className='w-full flex items-center justify-center transform transition-all ease-in-out duration-300'>
                      <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[30px] border-[#EB0728] px-[12px] h-[30px]">
                        <img src={errorIcon} alt="" className=" size-[14px]" />
                        <p className=" font-normal text-[#EB0728] text-[10px] leading-[12.13px]">
                          {recommendAgainError}
                        </p>
                      </div>
                    </div>
                  ) : null}
                  <div className='flex gap-[13px] flex-col  text-white lg:flex-row lg:justify-between '>

                    <h1 className=' font-medium text-[16px] leading-[21.6px]'>Would you recommend this vendor?</h1>
                    <div className='flex gap-[10px]'>
                      <button type='button' onClick={() => setRecommendAgain('Yes')} className={`w-[80px] h-[30px] rounded-[10px] flex items-center justify-center text-center ${recommendAgain === "Yes" ? "bg-[#4FBF26] text-white cursor-not-allowed" : "bg-white text-black cursor-pointer"} font-bold text-[16px] leading-[21.6px] transform transition-all ease-in-out duration-300`}>Yes</button>
                      <button type='button' onClick={() => setRecommendAgain('No')} className={`w-[80px] h-[30px] rounded-[10px] flex items-center justify-center text-center ${recommendAgain === "No" ? "bg-[#F32424] text-white cursor-not-allowed" : "bg-white text-black cursor-pointer"} font-bold text-[16px] leading-[21.6px] transform transition-all ease-in-out duration-300`}>No</button>
                    </div>

                  </div>


                </div>

              </div>
            </div>
            <div className="lg:hidden flex justify-center items-center mt-[24px] ">
              <button
                type="button"
                onClick={() => setStep(2)}
                className="w-[240px] h-[45px] items-center justify-center flex rounded-[80px] bg-[#0079FF] text-white font-bold"
              >
                Next
              </button>
            </div>
          </div>


          {/* MOBILE STEP 2 */}
          <div className={`${step === 2 ? "block" : "hidden"} lg:block`}>
            {/* second div */}
            <div className=' md:flex items-center justify-center '>
              <div className='mt-[54px] md:mt-0'>
                {/**Rate  */}
                {rateError === "Rate is required" ? (
                  <div className='w-full mb-[14px] flex items-center justify-center transform transition-all ease-in-out duration-300'>
                    <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[30px]  px-[12px] h-[30px]">
                      <img src={errorIcon} alt="" className=" size-[14px]" />
                      <p className=" font-normal text-[#EB0728] text-[10px] leading-[12.13px]">
                        {rateError}
                      </p>
                    </div>
                  </div>
                ) : null}

                <div className='hidden lg:flex  w-full items-center gap-[15px]'>

                  <h1 className='font-black text-sm'>Rate this vendor</h1>
                  <div className='flex items-center '>
                    {[...Array(5)].map((_, index) => (
                      <Star
                        key={index}
                        filled={index < rating}
                        onClick={() => handleClick(index)}
                      />
                    ))}
                  </div>
                </div>


                <div className='xl:flex items-center gap-[13px] w-full'>
                  {/**Select Event Date */}
                  <div className='mt-[23px] flex flex-col xl:flex-1'>

                    <div className='w-full flex flex-col  gap-[11px]'>
                      <h1 className=' font-black text-sm' >Event Info</h1>
                      {eventDateError === "Event Date is required" ? (
                        <div className='w-full flex items-center justify-center transform transition-all ease-in-out duration-300'>
                          <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[30px]  px-[12px] h-[30px]">
                            <img src={errorIcon} alt="" className=" size-[14px] " />
                            <p className=" font-normal text-[#EB0728] text-[10px] leading-[12.13px]">
                              {eventDateError}
                            </p>
                          </div>
                        </div>
                      ) : null}

                      <div
                        className={`w-full rounded-[80px] border border-[#c1c1c180]  ${eventDateError === "Event Date is required"
                          ? "border border-[#EB0728]  "
                          : ""
                          }`}
                      >
                        <CustomDatePicker eventDateError={eventDateError} selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
                      </div>

                    </div>
                  </div>

                  {/* Event type */}
                  <div className='mt-[24px] w-full flex flex-col xl:flex-1 xl:mt-[50px] gap-[11px]'>
                    {eventError === "Event is required" ? (
                      <div className='w-full flex items-center justify-center transform transition-all ease-in-out duration-300'>
                        <div className=" w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[30px]  px-[12px] h-[30px]">
                          <img src={errorIcon} alt="" className=" size-[14px] " />
                          <p className=" font-normal text-[#EB0728] text-[10px] leading-[12.13px]">
                            {eventError}
                          </p>
                        </div>
                      </div>
                    ) : null}
                    <RateEventSelector eventError={eventError} setEventError={setEventError} eventData={filteredEvents} handleEventSelect={handleEventSelect} selectedEvent={selectedEvent} device="large" />
                  </div>

                </div>

                {/* Estimate */}
                <h1 className=' font-black mt-[33px] lg:mt-5 mb-[10px] lg:mb-0 text-sm' >Price Estimate</h1>
                <div className='mt-[11px] border border-ravgray rounded-[20px] pt-[15px] pb-[24px] lg:pb-[17px] px-[14px]'>

                  {/**Info */}
                  <div className='w-full flex items-center justify-center'>
                    <div className=' rounded-[10px] bg-[#E7EFF8] max-w-[600px] flex gap-[12px] items-center justify-start pt-[9px] pb-[13px] px-[16px]'>
                      <img src={InfoIcon} alt="infoIcon" className='size-[20px]' />
                      <h1 className=' font-bold text-[12px] text-ravblue leading-[16.2px]'>To maintain confidentiality and trustworthiness, we do not disclose your estimate or display them on reviews</h1>
                    </div>
                  </div>

                  {/**Choose Currency of transaction */}
                  <div className=' mt-[24px] w-full flex flex-col gap-[15px] '>
                    <h1 className='text-black font-black text-base '>Choose currency of transaction</h1>

                    <div className="w-full grid grid-cols-2 lg:flex lg:flex-row gap-y-[20px] items-center lg:gap-[7px] xl:gap-[40px] ">
                      {currencies.map((currency) => (
                        <label key={currency?.id} className="flex items-center cursor-pointer">
                          <input
                            type="radio"
                            name="currency"
                            value={currency?.name}
                            checked={selectedCurrency?.name === currency?.name}
                            onChange={() => setSelectedCurrency(currency)}
                            className="hidden" // Hide the default radio button
                          />
                          <div
                            className={`flex items-center justify-center 
                                    w-[20px] h-[20px] rounded-full 
                                    bg-white border-[2px] border-solid border-[#0079FF]
                                    ${selectedCurrency?.name === currency?.name ? 'bg-white' : ''}`}
                          >
                            {selectedCurrency?.name === currency?.name && (
                              <div className="bg-[#0079FF] w-[12px] h-[12px] rounded-full"></div>
                            )}
                          </div>
                          <span className="ml-[11px] lg:ml-[5px] text-[12px] leading-[16.2px] text-ravinput">{currency?.name}</span>
                        </label>
                      ))}
                    </div>
                  </div>



                  {/**Services estimate */}
                  <div className=' mt-[34px] lg:mt-[32px] w-full flex flex-col gap-[15px] items-center '>


                    <div className='w-full flex flex-col mg:flex-row gap-[15px] mg:items-center  mg:gap-[11px] '>
                      <h1 className=' whitespace-nowrap font-black text-base'>Indicate services estimate:</h1>
                      <div className=''>
                        <div className={` w-[234px] lg:w-full  mg:w-[234px] h-[50px] flex gap-[10px] items-center border border-[#c1c1c180] bg-opacity-50 rounded-[80px] overflow-hidden`}>
                          <div className={`w-[73px] h-full bg-[#E5E5E5] rounded-l-[80px] flex items-center justify-center text-center font-medium text-sm`}>
                            <span>{selectedCurrency?.symbol}</span>
                          </div>
                          <input
                            type="text" // Change to text to allow formatted input
                            name="amount"
                            id="amount"
                            value={estimateAmount}
                            onChange={handleEstimateAmountChange}
                            placeholder='0.00'
                            onClick={() => setSearchError('')}
                            className="bg-transparent h-[50px] outline-none text-base placeholder:text-ravinput"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div className="w-full  hidden lg:block mt-4">
                  <button onClick={handleSubmit} type="button" className={`${loading ? 'bg-[#0079FF60] cursor-not-allowed' : 'bg-[#0079FF]'} w-full h-[45px] rounded-[80px] flex items-center justify-center font-bold text-white`}> Submit </button>
                </div>
              </div>


            </div>
            <div className="w-full flex justify-center mt-[25px] items-center lg:hidden ">
              <button onClick={handleSubmit} type="button" className={`${loading ? 'bg-[#0079FF60] cursor-not-allowed' : 'bg-[#0079FF]'} w-[240px] h-[45px]  rounded-[80px] flex items-center justify-center text-center font-bold text-white text-[16px] leading-[21.6px]`}> Submit </button>
            </div>
          </div>


        </div>


      </div>
      <Footer />
    </div>
  )
}

export default Rate
